import $axios2 from './request.js';

export default {
    init() {
      $axios2.post('/page/read').then(result => {})
    }
}
